import { render, staticRenderFns } from "./vehicleProcurement.vue?vue&type=template&id=c6dda6e0&scoped=true&"
import script from "./vehicleProcurement.vue?vue&type=script&lang=js&"
export * from "./vehicleProcurement.vue?vue&type=script&lang=js&"
import style0 from "./vehicleProcurement.vue?vue&type=style&index=0&id=c6dda6e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6dda6e0",
  null
  
)

export default component.exports